/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface Accept$Params {

/**
 * The ID of merchant having contract to be accepted
 */
  merchantId: string;

/**
 * The SHA-256 hash of document.
 */
  'If-Match': string;
}

export function accept(http: HttpClient, rootUrl: string, params: Accept$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, accept.PATH, 'post');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.header('If-Match', params['If-Match'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

accept.PATH = '/merchants/{merchantId}/contract';
